var map = {
	"./16_9.js": "RTK9",
	"./background.js": "NlpG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VbJT";


//////////////////
// WEBPACK FOOTER
// ./src/content/images nonrecursive \.js
// module id = VbJT
// module chunks = 1